import React, { Component } from 'react'
import { ReactComponent as Star } from './star.svg'
import { extendParentClass, extendBaseClass } from '../../../../utils/classes'

export class Stars extends Component {
  baseClass = extendParentClass.bind(this)('stars')

  extend = extendBaseClass.bind(this)

  renderStarsList = () => {
    const { stars } = this.props
    let starsList = []
    for (let starIndex = 0; starIndex < stars; starIndex++) {
      starsList.push(<Star key={starIndex} className={this.extend('item')} />)
    }
    return starsList
  }

  render() {
    return <div className={this.baseClass}>{this.renderStarsList()}</div>
  }
}

export default Stars
